export interface Testimonial {
  name: string
  role: string
  location: string
  text: string
  /** true until replaced with a verified customer review */
  isSample: boolean
}

// Draft reviews — replace with verified customer testimonials and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    name: 'Michael Carter',
    role: 'Automotive Technology Instructor',
    location: 'Texas, USA',
    text: 'I used to spend hours looking for diagrams, examples and activities before every class. Now I can open the system, choose the topic and already have a structured lesson ready to work with.',
    isSample: true,
  },
  {
    name: 'James Mitchell',
    role: 'Vocational Automotive Instructor',
    location: 'Manchester, UK',
    text: 'The visual material is what makes the biggest difference for me. Electrical systems, diagnostics and drivetrain concepts are much easier to explain when students can actually see how everything connects.',
    isSample: true,
  },
  {
    name: 'Andrew Wilson',
    role: 'Automotive Training Instructor',
    location: 'Sydney, Australia',
    text: 'I teach students with different experience levels, so having lessons, diagnostic scenarios and assessment tools already organized has made my planning much more consistent.',
    isSample: true,
  },
]
